const withFrozenTextCursor = (element: HTMLInputElement, fn: () => void) => {
  const { selectionStart, selectionEnd } = element;
  fn();
  element.selectionStart = selectionStart;
  element.selectionEnd = selectionEnd;
};

export default withFrozenTextCursor;
